import { useSearchParams } from 'react-router-dom';

import RegisterOfDebtors from '../Components/SectionsForRegisterPage/RegisterOfDebtors';
import RegisterOfApplicants from '../Components/SectionsForRegisterPage/RegisterOfApplicants';

import HeadlinePanel from '../Components/HeadlinePanel';

import subpageSelection from '../styles/SubpageSelection.module.css';

export default function Registers() {
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || 'debtors';

    return (
        <div className='mainContainer'>
            <HeadlinePanel label='Реестры' type='Назад' />
            <div className='containerInner'>
                <div className={subpageSelection.panel}>
                    <a onClick={() => setSearchParams({ section: 'debtors' })} className={`${subpageSelection.buttonToSubPages} ${section === 'debtors' ? subpageSelection.active : ''}`}>Реестр должников</a>
                    <a onClick={() => setSearchParams({ section: 'applicants' })} className={`${subpageSelection.buttonToSubPages} ${section === 'applicants' ? subpageSelection.active : ''}`}>Реестр заявителей</a>
                </div>
                <div className='pageWrapper'>
                    {section == 'debtors' ? <RegisterOfDebtors />
                    : section == 'applicants' ? <RegisterOfApplicants/>
                    : <a className='description'>Выберите вкладку</a>}
                </div>
            </div>
        </div>
    )
}
